__turbopack_context__.v({
  "badge": "ClubBadge-module__aMHhKq__badge",
  "compact": "ClubBadge-module__aMHhKq__compact",
});
